<template>
  <!-- the description is only worth a tooltip when there is one -->
  <tippy v-if="tier.description" :content="tier.description">
    <span class="tier-badge" :style="badge_style">
      <img v-if="tier.icon" :src="tier.icon" alt="" :style="icon_style" />
      {{ tier.name || placeholder }}
    </span>
  </tippy>
  <span v-else class="tier-badge" :style="badge_style">
    <img v-if="tier.icon" :src="tier.icon" alt="" :style="icon_style" />
    {{ tier.name || placeholder }}
  </span>
</template>

<script>
import { PREVIEW_SIZES } from './tierModel';

export default {
  name: 'TierBadge',

  props: {
    tier: {
      type: Object,
      required: true,
    },
    // one of the PREVIEW_SIZES heights, everything else scales off it
    size: {
      type: Number,
      default: 32,
    },
    placeholder: {
      type: String,
      default: 'Tier name',
    },
  },

  computed: {
    spec() {
      return PREVIEW_SIZES.find((item) => item.size === this.size) || PREVIEW_SIZES[1];
    },

    badge_style() {
      return {
        height: `${this.spec.size}px`,
        padding: `0 ${this.spec.padding}px`,
        gap: `${this.spec.gap}px`,
        fontSize: `${this.spec.font}px`,
        // one picker drives both the text and the border
        color: this.tier.font_color,
        borderColor: this.tier.font_color,
        backgroundColor: this.tier.background_color,
      };
    },

    icon_style() {
      return { width: `${this.spec.icon}px`, height: `${this.spec.icon}px` };
    },
  },
};
</script>
<style lang="scss">
// height, padding, gap, font size and icon size all come from PREVIEW_SIZES
.tier-badge {
  display: inline-flex;
  align-items: center;
  border: 1px solid;
  border-radius: 100px;
  font-family: var(--font-med);
  white-space: nowrap;

  img {
    object-fit: contain;
  }
}
</style>
